import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const cellSx = {
    height: '36px',
    fontSize: '14px',
    color: '#444',
    fontWeight: '500',
    padding: '4px 12px 4px 12px',
    whiteSpace: 'nowrap',
}

const headerSx = {
    height: '36px',
    backgroundColor: '#E5F3FF',
    color: '#202020',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'pre-line',
    padding: '4px 12px 4px 12px',
    lineHeight: 1.3,
}

const TrackTopupTable = ({ tableData = [], onSelect }) => {
    const columnDefs = [
        { headerName: 'OB Ref.\nNo', field: 'OBRefNo' },
        { headerName: 'Franchisee\nCode', field: 'FranchiseCode' },
        { headerName: 'Franchisee\nName', field: 'FranchiseName' },
        { headerName: 'Ticket\nNo', field: 'TicketNo' },
        { headerName: 'Top Up\nDate', field: 'RechargeDate' },
        { headerName: 'Top Up\nAmount', field: 'TopUpAmount', align: 'right' },
        { headerName: 'Payment\nMode', field: 'TopUpPaymentMode' },
        { headerName: 'PG Txn.\nStatus', field: 'PGtxnStatus' },
        { headerName: 'Topup\nStatus', field: 'TopUpStatus' },
        { headerName: 'Action', field: 'action' },
    ]

    return (
        <Box sx={{ padding: '12px 16px' }}>
            <TableContainer className='scrollBlue' component={Paper} sx={{
                maxHeight: '54vh',
                marginBottom: '5px',
            }}>
                <Table
                    stickyHeader
                    size="small"
                    aria-label="track topup table"
                    sx={{
                        '& .MuiTableCell-root': {
                            padding: '6px 8px !important',
                        },
                    }}
                >
                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                        <TableRow>
                            {columnDefs.map((col, index) => (
                                <TableCell
                                    key={`THR-${index}`}
                                    sx={{
                                        ...headerSx,
                                        textAlign: col.align || 'left',
                                    }}
                                >
                                    {col.headerName}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.map((val, index) => (
                            <TableRow key={`TD-${val?.RechargeID ?? index}`}>
                                <TableCell sx={cellSx}>{val?.OBRefNo || ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.FranchiseCode || ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.FranchiseName || ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.TicketNo || ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.RechargeDate || ''}</TableCell>
                                <TableCell sx={{ ...cellSx, textAlign: 'right' }}>{val?.TopUpAmount ?? ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.TopUpPaymentMode || ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.PGtxnStatus || ''}</TableCell>
                                <TableCell sx={cellSx}>{val?.TopUpStatus || ''}</TableCell>
                                <TableCell sx={{ ...cellSx, minWidth: '100px' }}>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        className="btn-orange"
                                        sx={{
                                            height: '24px',
                                            width: '60px',
                                            fontSize: '12px!important',
                                        }}
                                        onClick={() => onSelect(val)}
                                    >
                                        Select
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default TrackTopupTable
